import React from "react"
import { Col, ControlLabel, FormControl, FormGroup, HelpBlock } from "react-bootstrap"

export default function FormControlInlineDate({ controlId, validationState, label, placeholder, value,
  onChange, helpText, min, max, className, disabled }) {

  return (
    <FormGroup controlId={ controlId } validationState={ validationState }>

      <Col componentClass={ ControlLabel } sm={4}>
        { label }
      </Col>

      <Col sm={8}>
        <FormControl type="date" placeholder={ placeholder } className={ className }
          value={ value } onChange={e => onChange(e.target.value)}
          min={ min } max={ max } id={ controlId }
          disabled={ disabled }
        />
        <HelpBlock>{ helpText }</HelpBlock>
      </Col>

    </FormGroup>
  )
}


// WEBPACK FOOTER //
// ./src/components/fragments/FormControl.Inline.Date.js